import {
  TrackingEventID,
  TrackingEventPageID,
  TrackingEventType,
} from "@/shared";

enum TrackingButtonID {
  AddToShowcaseClick = 1,
  FreeSampleClick = 2,
  FavoriteClick = 3,
}

const Download = {
  event_id: TrackingEventID.ProductsDownload,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductsPage,
};

const Exposure = {
  event_id: TrackingEventID.ProductDetails,
  event_type: TrackingEventType.Exposure,
  page_id: TrackingEventPageID.ProductDetailsPage,
};

const AddToShowcase = {
  event_id: TrackingEventID.ProductDetails,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductDetailsPage,
  btn_id: TrackingButtonID.AddToShowcaseClick,
};

const FreeSample = {
  event_id: TrackingEventID.ProductDetails,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductDetailsPage,
  btn_id: TrackingButtonID.FreeSampleClick,
};

const Favorite = {
  event_id: TrackingEventID.ProductDetails,
  event_type: TrackingEventType.Click,
  page_id: TrackingEventPageID.ProductDetailsPage,
  btn_id: TrackingButtonID.FavoriteClick,
};

export const TrackingPoints = {
  Download,
  Exposure,
  AddToShowcase,
  FreeSample,
  Favorite,
};
